import {CampaignIntegrationsState} from './campaignIntegrations.types';

const campaignIntegrationsInitialState: CampaignIntegrationsState = {
  connectedCampaigns: [],
  integratedServices: [],
  areIntegrationsLoading: false,
};

export {campaignIntegrationsInitialState};
